import actionConstants from '../constants/';

const settlementState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const edgeSettlementListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const settlementsOverviewState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const settlementListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const deductionDetailsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const edgeSettlementDetailSummaryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: {},
};

const syncNowState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
};

const pgListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: [],
};

const settlementDownloadState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const statusListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: [],
};

const settlementDetailSummaryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: {},
};
const mprListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: [],
};

const transactionForUtrList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: [],
};

const transactionDetailsForUtr = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: [],
};

const mprFileLocationForUtr = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  data: [],
};

const mprRecoveryForUtr = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: { refundRecovery: 0, chargebackRecovery: 0 },
};

const settlementsSearchList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const settlementODSState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  isODS:false,
  message:'',
  time: '',
  statusData:{}
};

const ODSHistoryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data:[],
  errorMessage:'',
};

const pendingSettlementsListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const initialState = {
  settlementState: { ...settlementState },
  edgeSettlementListState: { ...edgeSettlementListState },
  settlementsOverviewState: { ...settlementsOverviewState },
  settlementListState: { ...settlementListState },
  syncNowState: { ...syncNowState },
  pgListState: { ...pgListState },
  statusListState: { ...statusListState },
  settlementDetailSummaryState: { ...settlementDetailSummaryState },
  settlementDownloadState: { ...settlementDownloadState },
  edgeSettlementDetailSummaryState: { ...edgeSettlementDetailSummaryState },
  mprListState: { ...mprListState },
  transactionForUtrList: { ...transactionForUtrList },
  transactionDetailsForUtr: { ...transactionDetailsForUtr },
  mprFileLocationForUtr: { ...mprFileLocationForUtr },
  mprRecoveryForUtr: { ...mprRecoveryForUtr },
  settlementsSearchList: { ...settlementsSearchList },
  deductionDetailsState: {...deductionDetailsState},
  settlementODSState: {...settlementODSState},
  ODSHistoryState: {...ODSHistoryState},
  pendingSettlementsListState: {...pendingSettlementsListState},
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function settlementsReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_SETTLEMENT_DATA_REQUEST:
      return {
        ...state,
        settlementState: {
          ...state.settlementState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SETTLEMENT_DATA_SUCCESS:
      return {
        ...state,
        settlementState: {
          ...state.settlementState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_SETTLEMENT_DATA_FAILURE:
      return {
        ...state,
        settlementState: {
          ...state.settlementState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_SETTLEMENT_DATA_CLEAR:
      return {
        ...state,
        settlementState,
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DATA_REQUEST:
      return {
        ...state,
        edgeSettlementListState: {
          ...state.edgeSettlementListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DATA_SUCCESS:
      return {
        ...state,
        edgeSettlementListState: {
          ...state.edgeSettlementListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DATA_FAILURE:
      return {
        ...state,
        edgeSettlementListState: {
          ...state.edgeSettlementListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DATA_CLEAR:
      return {
        ...state,
        edgeSettlementListState,
      };

    case actionConstants.GET_SYNC_NOW_REQUEST:
      return {
        ...state,
        syncNowState: {
          ...state.syncNowState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SYNC_NOW_SUCCESS:
      return {
        ...state,
        syncNowState: {
          ...state.syncNowState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_SYNC_NOW_FAILURE:
      return {
        ...state,
        syncNowState: {
          ...state.syncNowState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_PG_LIST_REQUEST:
      return {
        ...state,
        pgListState: {
          ...state.pgListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_PG_LIST_SUCCESS:
      return {
        ...state,
        pgListState: {
          ...state.pgListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_PG_LIST_FAILURE:
      return {
        ...state,
        pgListState: {
          ...state.pgListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_SETTLEMENT_STATUS_LIST_REQUEST:
      return {
        ...state,
        statusListState: {
          ...state.statusListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SETTLEMENT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        statusListState: {
          ...state.statusListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_SETTLEMENT_STATUS_LIST_FAILURE:
      return {
        ...state,
        statusListState: {
          ...state.statusListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAIL_SUMMARY_REQUEST:
      return {
        ...state,
        settlementDetailSummaryState: {
          ...state.settlementDetailSummaryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAIL_SUMMARY_SUCCESS:
      return {
        ...state,
        settlementDetailSummaryState: {
          ...state.settlementDetailSummaryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAIL_SUMMARY_FAILURE:
      return {
        ...state,
        settlementDetailSummaryState: {
          ...state.settlementDetailSummaryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_REQUEST:
      return {
        ...state,
        edgeSettlementDetailSummaryState: {
          ...state.edgeSettlementDetailSummaryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_SUCCESS:
      return {
        ...state,
        edgeSettlementDetailSummaryState: {
          ...state.edgeSettlementDetailSummaryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_FAILURE:
      return {
        ...state,
        edgeSettlementDetailSummaryState: {
          ...state.edgeSettlementDetailSummaryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENT_DETAIL_SUMMARY_CLEAR:
      return {
        ...state,
        edgeSettlementDetailSummaryState,
      };

    case actionConstants.GET_SETTLEMENT_DOWNLOAD_REQUEST:
      return {
        ...state,
        settlementDownloadState: {
          ...state.settlementDownloadState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SETTLEMENT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        settlementDownloadState: {
          ...state.settlementDownloadState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_SETTLEMENT_DOWNLOAD_FAILURE:
      return {
        ...state,
        settlementDownloadState: {
          ...state.settlementDownloadState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_SETTLEMENT_DOWNLOAD_CLEAR:
      return {
        ...state,
        settlementDownloadState: {
          ...settlementDownloadState,
        },
      };

    case actionConstants.GET_EDGE_MPR_LIST_REQUEST:
      return {
        ...state,
        mprListState: {
          ...state.mprListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_EDGE_MPR_LIST_SUCCESS:
      return {
        ...state,
        mprListState: {
          ...state.mprListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_MPR_LIST_FAILURE:
      return {
        ...state,
        mprListState: {
          ...state.mprListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_MPR_LIST_CLEAR:
      return {
        ...state,
        mprListState: {
          ...initialState.mprListState,
          data: {},
        },
      };

      case actionConstants.GET_EDGE_SETTLEMENT_DATA_OVERVIEW_REQUEST:
        return {
          ...state,
          settlementsOverviewState: {
            ...state.settlementsOverviewState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
          },
        };
  
      case actionConstants.GET_EDGE_SETTLEMENT_DATA_OVERVIEW_SUCCESS:
        return {
          ...state,
          settlementsOverviewState: {
            ...state.settlementsOverviewState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
          },
        };
  
      case actionConstants.GET_EDGE_SETTLEMENT_DATA_OVERVIEW_FAILURE:
        return {
          ...state,
          settlementsOverviewState: {
            ...state.settlementsOverviewState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
          },
        };
  
      case actionConstants.GET_EDGE_SETTLEMENT_DATA_OVERVIEW_CLEAR:
        return {
          ...state,
          settlementsOverviewState,
        };
  
        case actionConstants.GET_EDGE_SETTLEMENT_LIST_REQUEST:
          return {
            ...state,
            settlementListState: {
              ...state.settlementListState,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_LIST_SUCCESS:
          return {
            ...state,
            settlementListState: {
              ...state.settlementListState,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_LIST_FAILURE:
          return {
            ...state,
            settlementListState: {
              ...state.settlementListState,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_LIST_CLEAR:
          return {
            ...state,
            settlementListState,
          };
    
        
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_LIST_REQUEST:
          return {
            ...state,
            transactionForUtrList: {
              ...state.transactionForUtrList,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_LIST_SUCCESS:
          return {
            ...state,
            transactionForUtrList: {
              ...state.transactionForUtrList,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_LIST_FAILURE:
          return {
            ...state,
            transactionForUtrList: {
              ...state.transactionForUtrList,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_LIST_CLEAR:
          return {
            ...state,
            transactionForUtrList,
          };

        case actionConstants.GET_SETTLEMENT_MPR_FILE_LOCATION_REQUEST:
          return {
            ...state,
            mprFileLocationForUtr: {
              ...state.mprFileLocationForUtr,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
            },
          };

        case actionConstants.GET_SETTLEMENT_MPR_FILE_LOCATION_SUCCESS:
          return {
            ...state,
            mprFileLocationForUtr: {
              ...state.mprFileLocationForUtr,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
            },
          };

        case actionConstants.GET_SETTLEMENT_MPR_FILE_LOCATION_FAILURE:
          return {
            ...state,
            mprFileLocationForUtr: {
              ...state.mprFileLocationForUtr,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
            },
          };

        case actionConstants.GET_SETTLEMENT_MPR_FILE_LOCATION_CLEAR:
          return {
            ...state,
            mprFileLocationForUtr,
          };

        case actionConstants.GET_SETTLEMENT_MPR_RECOVERY_REQUEST:
          return {
            ...state,
            mprRecoveryForUtr: {
              ...state.mprRecoveryForUtr,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
            },
          };

        case actionConstants.GET_SETTLEMENT_MPR_RECOVERY_SUCCESS:
          return {
            ...state,
            mprRecoveryForUtr: {
              ...state.mprRecoveryForUtr,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
            },
          };

        case actionConstants.GET_SETTLEMENT_MPR_RECOVERY_FAILURE:
          return {
            ...state,
            mprRecoveryForUtr: {
              ...state.mprRecoveryForUtr,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
            },
          };

        case actionConstants.GET_SETTLEMENT_MPR_RECOVERY_CLEAR:
          return {
            ...state,
            mprRecoveryForUtr,
          };

          case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_REQUEST:
          return {
            ...state,
            transactionDetailsForUtr: {
              ...state.transactionDetailsForUtr,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_SUCCESS:
          return {
            ...state,
            transactionDetailsForUtr: {
              ...state.transactionDetailsForUtr,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_FAILURE:
          return {
            ...state,
            transactionDetailsForUtr: {
              ...state.transactionDetailsForUtr,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
            },
          };
    
        case actionConstants.GET_EDGE_SETTLEMENT_TRANSACTION_DETAILS_CLEAR:
          return {
            ...state,
            transactionDetailsForUtr,
          };


          case actionConstants.SETTLEMENTS_SEARCH_REQUEST:
          return {
            ...state,
            settlementsSearchList: {
              ...state.settlementsSearchList,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
            },
          };
    
        case actionConstants.SETTLEMENTS_SEARCH_SUCCESS:
          return {
            ...state,
            settlementsSearchList: {
              ...state.settlementsSearchList,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
            },
          };
    
        case actionConstants.SETTLEMENTS_SEARCH_FAILURE:
          return {
            ...state,
            settlementsSearchList: {
              ...state.settlementsSearchList,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
            },
          };
    
        case actionConstants.SETTLEMENTS_SEARCH_CLEAR:
          return {
            ...state,
            settlementsSearchList,
          };
      case actionConstants.GET_ONDEMAND_SETTLEMENT_STATUS_REQUEST:
        return {
          ...state,
          settlementODSState: {
            ...state.settlementODSState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
          },
        };

    case actionConstants.GET_ONDEMAND_SETTLEMENT_STATUS_SUCCESS:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          statusData: action.payload.body,
        },
      };

    case actionConstants.GET_ONDEMAND_SETTLEMENT_STATUS_FAILURE:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.GET_DEDUCTION_DETAILS_REQUEST:
      return {
        ...state,
        deductionDetailsState: {
          ...state.deductionDetailsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_DEDUCTION_DETAILS_SUCCESS:
      return {
        ...state,
        deductionDetailsState: {
          ...state.deductionDetailsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_DEDUCTION_DETAILS_FAILURE:
      return {
        ...state,
        deductionDetailsState: {
          ...state.deductionDetailsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_DEDUCTION_DETAILS_CLEAR:
      return {
        ...state,
        deductionDetailsState,
      };
    case actionConstants.POST_ONDEMAND_SETTLEMENT_SUCCESS:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          message: action.payload.body,
        },
      };
    case actionConstants.POST_ONDEMAND_SETTLEMENT_REQUEST:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    case actionConstants.POST_ONDEMAND_SETTLEMENT_FAILURE:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.POST_ONDEMAND_SETTLEMENT_CLEAR:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          message: '',
          statusData: {},
          data: {},
        },
      };
    case actionConstants.GET_ONDEMAND_SETTLEMENT_SUCCESS:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_ONDEMAND_SETTLEMENT_FAILURE:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.GET_ONDEMAND_SETTLEMENT_REQUEST:
      return {
        ...state,
        settlementODSState: {
          ...state.settlementODSState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_REQUEST:
      return {
        ...state,
        ODSHistoryState: {
          ...state.ODSHistoryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_SUCCESS:
      return {
        ...state,
        ODSHistoryState: {
          ...state.ODSHistoryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
        },
      };
    case actionConstants.GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_FAILURE:
      return {
        ...state,
        ODSHistoryState: {
          ...state.ODSHistoryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.GET_ONDEMAND_SETTLEMENT_HISTORY_DATA_CLEAR:
      return {
        ...state,
        ODSHistoryState: {
          ...initialState.ODSHistoryState,
          data: [],
        },
      };

    // Pending Settlements List
    case actionConstants.GET_PENDING_SETTLEMENTS_LIST_REQUEST:
      return {
        ...state,
        pendingSettlementsListState: {
          ...state.pendingSettlementsListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    case actionConstants.GET_PENDING_SETTLEMENTS_LIST_SUCCESS:
      return {
        ...state,
        pendingSettlementsListState: {
          ...state.pendingSettlementsListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_PENDING_SETTLEMENTS_LIST_FAILURE:
      return {
        ...state,
        pendingSettlementsListState: {
          ...state.pendingSettlementsListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    default:
      return {
        ...state,
      };
  }
}
